import { apiGet } from "./client";

export interface DashboardSummary {
  project_name?: string;
  company_number?: number;
  asset_number?: number;
  company_dashboard?: any[];
  inferred_datas?: any;
  [key: string]: unknown;
}

export function getSummary(scenarioId: number): Promise<DashboardSummary> {
  return apiGet<DashboardSummary>(`/summary/${scenarioId}`);
}

export function getSensitivitySummary(
  scenarioId: number,
  sensitivityId: number,
): Promise<DashboardSummary> {
  return apiGet<DashboardSummary>(
    `/summary/${scenarioId}/${sensitivityId}`,
  );
}
